import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios instance with credentials (cookies) — required for auth
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
